import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createPortionLabelSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { parse, toString } from 'Lib/Object/Path/shared';
import { dropLast } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../../Layout';
import { WorksheetAssociatedTestSection } from '../../../../../Core';

let SubspecimenWetMassesSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  // Have to go up two levels to find the separated portion
  const separatedPortionPath = toString(dropLast(2, parse(namePrefix!)));
  const isFirstSubspecimen = separatedPortionPath.endsWith('.WholePortion');

  const subsampledPortionLabel = useSelector(createPortionLabelSelector(createWorksheetSelector!, `${namePrefix}`));

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.WetMass" label={`${subsampledPortionLabel} Wet Mass`} />
      </ListFieldSection>
      <NamePrefixModifier appendNamePrefix="Subspecimen">
        <WorksheetAssociatedTestSection
          heading="Water Content"
          name="Masses.AssociatedMoistureContent"
          testType="Moisture Content"
          associatedTestModel={{
            measured: true,
          }}
        />
      </NamePrefixModifier>

      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.DryMass" label={`${subsampledPortionLabel} Dry Mass`} />
        <NamePrefixModifier namePrefix={separatedPortionPath}>
          <Field
            input={<TextOutput />}
            name="Masses.DryMass"
            label="Specimen Total Dry Mass"
            visible={isFirstSubspecimen}
          />
        </NamePrefixModifier>
      </ListFieldSection>
    </>
  );
};

SubspecimenWetMassesSection = withInjectedProps(SubspecimenWetMassesSection);

export { SubspecimenWetMassesSection };
export default SubspecimenWetMassesSection;
